export default __webpack_public_path__ + "static/media/vacancy-homecard.5f774eb3.svg";